import { render, staticRenderFns } from "./WidgetDatetime.vue?vue&type=template&id=5fff7081&scoped=true&"
import script from "./WidgetDatetime.vue?vue&type=script&lang=ts&"
export * from "./WidgetDatetime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff7081",
  null
  
)

export default component.exports